import{ useState } from "react";
import { useNavigate } from "react-router-dom";
import MobileHeader from "../../components/MobileHeader";
import Header from "../../components/header";
import { useMediaQuery } from "react-responsive";
import {  validateUniversity } from "../../components/regression";
const BASE_URL = process.env.REACT_APP_BASE_URL;

function CreateProfile() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [institution, setInstitution] = useState("");
  const [research_areas, setResearchAreas] = useState("");
  const [bio, setBio] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });


  const handleCreateProfile = async () => {
    setError("");
    setMessage("");

    const token = localStorage.getItem("access_token");
    if (!token) {
      setError("You must be logged in to create a profile.");
      return;
    }
    const trimmedName = name.trim();
    if (!trimmedName) {
      setError("Name is required.");
      return;
    }
const nameRegex = /^(?!.*([\p{L}])\1{3,})(?:[A-Z][\p{L}.'’-]*\s?)+$/u;

    if (!nameRegex.test(trimmedName)) {
        setError("Please enter a valid full name.");
        return;
   }
    if (!institution.trim()) {
      setError("University Name is required.");
      return;
    }
    if(validateUniversity(institution))
    {
      setError("Please enter a valid university name.");
      return;
    }
    if (!research_areas || !research_areas.trim()) {
    setError("Please enter at least one research area.");
    return;
  }
  
  const areas = research_areas
    .split(',')
    .map(a => a.trim())
    .filter(a => a);

  // 1️⃣ Max 5 areas
  if (areas.length > 5) {
    setError("You can enter a maximum of 5 research areas only.");
    return;
  }
  const areaRegex = /^[\p{L}0-9\s-]{1,200}$/u;
  // 2️⃣ Check each area
  for (let area of areas) {
    if (area.length > 200) {
      setError(`Research area "${area}" exceeds 200 characters.`);
      return;
    }

    if (!areaRegex.test(area)) {
      setError(`Research area "${area}" contains invalid characters. Only letters, numbers, spaces, and hyphens are allowed.`);
      return;
    }
    if (/([\p{L}])\1{3,}/u.test(area)) {
      setError(`Research area "${area}" contains repeated letters more than 3 times.`);
      return;
    }
  }
 if (!bio || !bio.trim()) {
  setError("Please enter a short bio.");
  return;
}
// Check length separately
if (bio.length > 300) {
  setError("Short Bio cannot exceed 300 characters.");
  return;
}

// Only letters (Unicode), numbers, spaces, and basic punctuation
 const bioRegex = /^[\p{L}\p{N}\p{P}\p{Zs}]{1,300}$/u;
  if (!bioRegex.test(bio)) {
    setError("Short Bio contains invalid characters.");
    return;
  }

  // Block excessive repeated letters (>3)
  if (/([\p{L}])\1{3,}/u.test(bio)) {
    setError("Short Bio contains excessive repeated letters.");
    return;
  }

  if(!profilePicture) {
    setError('profile picture is required')
    return;
  }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("institution", institution);
    formData.append("research_areas", research_areas);
    formData.append("bio", bio);

    if (profilePicture) {
      formData.append("profile_picture", profilePicture);
    }
    // alert('success')
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/user/profile/create-profile/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
        body: formData,
      });

      const data = await response.json();
      if (!response.ok) {
        console.error("Server error:", data);
        setError(data.message || data.error || "Failed to create profile.");
      } else {
        setMessage("Profile created successfully!");
        setTimeout(() => {
          navigate("/home");
        }, 1500);
      }
    } catch (err) {
      console.error("Network error:", err);
      setError("Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
  {isMobile ? (
    <MobileHeader hideSearchBar={true} hideHome={true} hideLogo={true} hideBell={true} />
  ) : (
    <Header hideSearchBar={true} hideHome={true} hideLogo={true} hideBell={true} />
  )}

  <div className="bg-gray-50 w-full min-h-screen flex justify-center items-center p-4">
    <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg p-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
          <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Let's create your profile</h2>
          <p className="text-gray-500 mt-1">We'll personalize your experience — it only takes about 3 minutes.</p>
        </div>
      </div>

      {/* Form */}
      <div className="space-y-4">
        {/* Name */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <label className="text-sm font-semibold text-gray-700">Name</label>
          </div>
          <input
            type="text"
            placeholder="Enter your full name"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        {/* Institution */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <label className="text-sm font-semibold text-gray-700">Institution</label>
          </div>
          <input
            type="text"
            placeholder="University, Company, or Organization"
            className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            value={institution}
            onChange={(e) => setInstitution(e.target.value)}
          />
        </div>

        {/* Research Area */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <label className="text-sm font-semibold text-gray-700">Research Areas</label>
          </div>
          <textarea
            placeholder="Separate research areas with commas"
            className="w-full min-h-[100px] px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-y transition-all"
            value={research_areas}
            onChange={(e) => setResearchAreas(e.target.value)}
          />
        </div>

        {/* Bio */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <label className="text-sm font-semibold text-gray-700">Short Bio</label>
          </div>
          <textarea
            placeholder="Brief professional biography"
            className="w-full min-h-[100px] px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-y transition-all"
            value={bio}
            onChange={(e) => setBio(e.target.value)}
          />
        </div>

        {/* Profile Picture Upload */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <label className="text-sm font-semibold text-gray-700">Profile Picture</label>
          </div>
          <div className="relative">
            <input
              type="file"
              accept="image/*"   
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
              onChange={(e) => setProfilePicture(e.target.files[0])}
            />
            <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors">
              <div className="w-16 h-16 bg-[#e8f0f7] rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-sm text-gray-600">Click to upload profile picture</p>
              <p className="text-xs text-gray-400 mt-1">JPG, PNG up to 5MB</p>
            </div>
          </div>
          
          {profilePicture && (
            <div className="mt-4 flex justify-center">
              <div className="relative">
                <img
                  src={URL.createObjectURL(profilePicture)}
                  alt="Profile Preview"
                  className="w-32 h-32 rounded-2xl object-cover border-4 border-white shadow-lg"
                />
                <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
            </div>
          )}
        </div>

        {/* Messages */}
        {error && (
          <div className="p-3 bg-red-50 text-red-600 rounded-xl text-sm">
            {error}
          </div>
        )}
        {message && (
          <div className="p-3 bg-green-50 text-green-600 rounded-xl text-sm">
            {message}
          </div>
        )}

        {/* Submit Button */}
        <button
          className="w-full py-3.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          onClick={handleCreateProfile}
          disabled={loading}
        >
          {loading ? (
            <>
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              Creating Profile...
            </>
          ) : (
            "Create Profile"
          )}
        </button>
      </div>
    </div>
  </div>
</>
  );
}

export default CreateProfile;
